import { SalaryCertificateFormValues } from './types';

export const initialValuesForm: SalaryCertificateFormValues = {
  purpose: null,
  requiredByDate: '',
  language: '',
  remarks: '',
};
